import * as R from "ramda";

import { FETCH_TEAMS } from "../actions/teams";
import { CREATE_TEAM, UPDATE_TEAM } from "../actions/team";
import { SELECT_COMPANY } from "../actions/company";

export const initialState = null;

const teams = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_TEAMS.RESOLVED:
      return payload;

    case CREATE_TEAM.RESOLVED:
      return R.append(payload, state);

    case UPDATE_TEAM.RESOLVED:
      return state.map(team => (team.id === payload.id ? payload : team));

    case SELECT_COMPANY.TYPE:
      return initialState;

    default:
      return state;
  }
};

export default teams;
